export enum Breakpoints {
  MobileExtraSmallStart = 0,
  MobileExtraSmallEnd = 350,
  MobileSmallStart = 351,
  MobileSmallEnd = 490,
  MobileStart = 491,
  MobileEnd = 575,
  TabletStart = 576,
  TabletEnd = 767,
  TabletLargeStart = 768,
  TabletLargeEnd = 991,
  DesktopStart = 992,
  DesktopEnd = 1199,
  DesktopLargeStart = 1200,
  DesktopLargeEnd = 1499,
  DesktopExtraLargeStart = 1500,
  DesktopExtraLargeEnd = 8000,
}